interface UseGalleryPageOptions {
  defaultPerPage?: number
}

export const useGalleryPage = async (options?: UseGalleryPageOptions) => {
  const nuxtApp = useNuxtApp()
  const categoryEventName = 'Gallery'
  const eventName = 'click_gallery_category'

  const {
    breadcrumbs,
    asyncCategory,
    items: gallery,
    page,
    perPage,
    total,
  } = await useListApi<GalleryMeta>({
    categoryApiPath: '/gallery-categories',
    itemPath: '/gallery?orderBy=position&sortBy=asc',
    categoryField: 'galleryCategoryId',
    componentName: 'Gallery',
    hasCategory: true,
    defaultPerPage: options?.defaultPerPage ?? 24,
  })

  const galleries = computed(() => {
    const mapNewData = gallery.value.length > 0
      ? gallery.value.map((item) => {
        return {
          image: item.image,
          title: item.title,
          description: item.description,
        }
      })
      : []
    return mapNewData
  })

  const { slugPageInfo, domain, getPath } = useNavigationMenu()
  const { isMainLanguage } = useLanguage()
  const currentCategory = computed(() => asyncCategory.value?.category)
  useCustomSeo({
    title: () => currentCategory.value?.metaTitleFront || slugPageInfo.value?.metaTitleFront,
    description: () =>
      currentCategory.value?.metaDescriptionFront ||
      slugPageInfo.value?.metaDescriptionFront ||
      slugPageInfo.value?.description,
    image: () => currentCategory.value?.ogImage?.large || slugPageInfo.value?.ogImage?.large,
    noindex: () => !isMainLanguage.value && gallery.value.length === 0,
  })

  // Add gallery schema
  const { currentLocaleCode } = useLanguage()
  nuxtApp.runWithContext(() => useSchemaOrg([
    defineWebPage({
      '@type': 'CollectionPage',
      '@id': `${domain.value}${getPath({ componentName: 'Gallery' })}#webpage`,
      name: currentCategory.value?.metaTitleFront || slugPageInfo.value?.metaTitleFront,
      url: `${domain.value}${getPath({ componentName: 'Gallery' })}`,
      inLanguage: currentLocaleCode.value,
      isPartOf: { '@id': `${domain.value}/#website` },
      publisher: { '@id': `${domain.value}/#organization` },
      mainEntity: galleries.value.map(item => ({
        '@type': 'ImageObject',
        contentUrl: item.image?.large || '',
        caption: item.title || '',
        description: item.description || '',
        creator: { '@id': `${domain.value}/#organization` },
      })),
    }),
    defineItemList({
      '@id': `${domain.value}${getPath({ componentName: 'Gallery' })}#category-list`,
      itemListElement: asyncCategory.value?.categoryButtonItems?.map((cat, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: cat.title,
        url: `${domain.value}${cat.path}`,
      })),
    }),
  ]))

  return {
    categoryEventName,
    eventName,
    breadcrumbs,
    asyncCategory,
    page,
    perPage,
    total,
    galleries,
  }
}
